module.exports = __webpack_public_path__ + "static/media/buffalo_map_thumb_home.f4a97786.jpg";